export function formatCurrency(value: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatNumber(value: number, decimals = 2): string {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

/**
 * Parses a date string that may arrive in several shapes:
 *  - ISO with a "T" and/or "Z"
 *  - "YYYY-MM-DD HH:MM:SS" (SQLite's datetime('now'), no timezone)
 *  - "YYYY.MM.DD HH:MM:SS" (MQL5's TimeToString() default format)
 */
function parseFlexibleDate(value: string): Date | null {
  let s = value.replace(/^(\d{4})\.(\d{2})\.(\d{2})/, "$1-$2-$3");
  if (!s.includes("T")) s = s.replace(" ", "T");
  if (!/Z$|[+-]\d{2}:\d{2}$/.test(s)) s += "Z";
  const date = new Date(s);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateTime(value: string | null): string {
  if (!value) return "Never";
  const date = parseFlexibleDate(value);
  if (!date) return "Unknown";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function relativeTime(value: string | null): string {
  if (!value) return "never";
  const date = parseFlexibleDate(value);
  if (!date) return "unknown";
  const diffSeconds = Math.round((Date.now() - date.getTime()) / 1000);
  if (diffSeconds < 60) return `${diffSeconds}s ago`;
  if (diffSeconds < 3600) return `${Math.round(diffSeconds / 60)}m ago`;
  if (diffSeconds < 86400) return `${Math.round(diffSeconds / 3600)}h ago`;
  return `${Math.round(diffSeconds / 86400)}d ago`;
}
